import * as tslib_1 from "tslib";
import * as React from 'react';
import { MailFolderList } from 'owa-mail-folder-view';
import { observer } from 'mobx-react';
import getFolderViewStateFromId from 'owa-mail-folder-store/lib/selectors/getFolderViewStateFromId';
import toggleFolderNodeExpansion from 'owa-mail-folder-store/lib/actions/toggleFolderNodeExpansion';
import { logRootFolderNodeClick } from 'owa-mail-folder-store';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import { lazyDeleteFolderInFolderForest } from 'owa-mail-folder-forest-actions';
import { isFolderUnderDeletedItemsFolder } from 'owa-mail-store';
import { getArchiveMailboxRootFolder, getMailboxLoadingState, lazyGetArchiveFolders, ARCHIVE_FOLDER_ROOT_DISTINGUISHED_ID, ARCHIVE_DELETED_ITEMS_DISTINGUISHED_ID, } from 'owa-folders';
var FOLDER_PANE = 'FOLDER_PANE';
/**
 * Archive mailbox container
 */
function ArchiveMailFolderTreeContainer(props) {
    var _this = this;
    var archiveRootFolder = getArchiveMailboxRootFolder();
    var isArchiveRootExpanded = getFolderViewStateFromId(archiveRootFolder.distinguishedFolderId)
        .isExpanded;
    // Archive mailbox root click handler. The getArchiveFolders orchestrator shall fetch the folders
    // only if they are not fetched successfully previously
    var onRootNodeChevronClicked = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, lazyGetArchiveFolders.import()];
                case 1:
                    (_a.sent())(FOLDER_PANE /* Archive mailbox folders loading source */);
                    toggleFolderNodeExpansion(archiveRootFolder.distinguishedFolderId, true);
                    logRootFolderNodeClick(archiveRootFolder.distinguishedFolderId);
                    return [2 /*return*/];
            }
        });
    }); };
    var onDeleteFolder = function (folder, actionSource) {
        var archiveDeletedItemsFolderId = folderNameToId(ARCHIVE_DELETED_ITEMS_DISTINGUISHED_ID);
        var isFolderUnderDeletedItemFolder = isFolderUnderDeletedItemsFolder(folder, ARCHIVE_DELETED_ITEMS_DISTINGUISHED_ID);
        lazyDeleteFolderInFolderForest.importAndExecute(folder.FolderId.Id, actionSource, archiveDeletedItemsFolderId, isFolderUnderDeletedItemFolder);
    };
    return (React.createElement(MailFolderList, { className: props.className, key: "archivemailboxtree", showRootNode: true, rootFolder: archiveRootFolder, isRootExpanded: isArchiveRootExpanded, rootDisplayName: archiveRootFolder.DisplayName, childFolderIds: archiveRootFolder.childFolderIds, onRootNodeChevronClickedCallback: onRootNodeChevronClicked, treeType: 'archiveFolderTree', isFavoritesSupported: false, onDeleteFolderCallback: onDeleteFolder, loadingState: getMailboxLoadingState(ARCHIVE_FOLDER_ROOT_DISTINGUISHED_ID) }));
}
export default observer(ArchiveMailFolderTreeContainer);
//# sourceMappingURL=ArchiveMailFolderTreeContainer.js.map